/**
 * Module-level caches holding what one signed-in user read: names, dates, who could take a task.
 * Each registers how to empty itself, and signing out empties them all, so the next person on the
 * same tab, perhaps at another clinic or in another region, never sees the last one's reads.
 */
const clears = new Set();

/** @param {() => void} clear - empties one cache */
export const clearOnSignOut = (clear) => {
  clears.add(clear);
};

export const clearSignedInCaches = () => clears.forEach((clear) => clear());
